export default "__VITE_ASSET__BCjtWxT___"